import { Link } from "react-router-dom";

function PageNotFound(params) {
  return (
    <>
      <h2>Page Not Found - 404</h2>
      <Link style={{ color: "rgb(251, 98, 54)" }} to="/menu">
        Hungry? Let’s get started 🍽️
      </Link>{" "}
      😊 <br />
      <span style={{ fontSize: "200px" }}>🍽</span>
    </>
  );
}

export default PageNotFound;
